import React from 'react';
import DOMPurify from 'dompurify';
import Label from '../label/Label';
import { ErrorMessage } from 'formik';

function TextArea({
	label,
	labelfontWeight = 'bold',
	placeholder = 'Type here',
	rows = '4',
	customClasses = '',
	shadow = true,
	value = '',
	onChangeCb = () => { },
	disabled = false,
	isRequired = false,
	name = "",
	errorContainerClasses = "",
}) {
	const handleInput = (e) => {
		e.target.value = e.target.value.replace(/[<>]/g, '');
	};

	const handleChange = (e) => {
		const cleanValue = DOMPurify.sanitize(e.target.value);
		onChangeCb({ ...e, target: { ...e.target, value: cleanValue } });
	};

	return (
		<>
			<Label fontWeight={labelfontWeight} isRequired={isRequired}>{label}</Label>
			<textarea
				rows={rows}
				className={`focus:outline-none placeholder-gray-500 bg-white p-2 w-full rounded-md fs-14 text-gray-600 ${customClasses} ${shadow ? 'box-shadow-1' : ''}`}
				value={value}
				placeholder={placeholder}
				onInput={handleInput}
				onChange={handleChange}
				disabled={disabled}
				name={name}
			></textarea>
			{name && <div className={`mt-1 ${errorContainerClasses}`}>
				<ErrorMessage name={name}>{msg => <div className="error-text">{typeof msg === 'string' ? msg : msg.label}</div>}</ErrorMessage>
			</div>}
		</>
	);
}

export default TextArea;
